import { getSdk } from "../../services/sdkService";
import { i18n } from "../../services/i18nService";
import { getErrorCode } from "../../errors/codes";
import { config } from "../../config/config";
import {  getAppState } from "../../state";

export async function checkDevice() {
  const sdk = await getSdk();
  const checkResult = (await sdk.userManager.checkDeviceCanPlay()) || {};
  console.log('checkResult', checkResult);
  if (checkResult && checkResult.status && checkResult.status === 403) {
    await getAppState().setForceLogout(checkResult);
  } 
  if (checkResult && !checkResult.deviceAlreadyRegistered) {
    // If the device is not registered, try to register it regardless the list is full or not
    try {
      await addDevice.call(this, checkResult.deviceId);
    } catch (e) {
      // FIXME If I'm not wrong, the SDK won't return e.reason anymore but codes instead. Please review.
      if (e.reason === "timeout") {
        e.message = i18n.get("global.errors.timeout.text");
        const code = getErrorCode("loadTimeoutError");
        sdk.reportsManager.sendReport(
          { level: "error", event: "Playback", env: config.get().sdk.environment },
          {
            eventId: "PlayerError",
            report: code,
            status: "error",
            parameter: {
              errorCode: code,
              dump: {
                timedOutCall: "addDevice"
              }
            }
          }
        );
      } else {
        if (
          !checkResult.freeDeviceSlotsExist ||
          e.code === sdk.userManager.userErrorCodes.MAX_AMOUNT_OF_DEVICES_REACHED
        ) {
          // If adding the device failed and the check reported there were no free device slots, return the original
          // check result so that the scenario is treated as a 'full devices list' case, instead of a 'device addition
          // failure'
          return checkResult;
        } else {
          await getAppState().setForceLogout(e);
          e.message = i18n.get("pages.player.errors.addDeviceError");
        }
      }
      throw e;
    }
  }
  return checkResult;
}

async function addDevice(deviceId) {
  const sdk = await getSdk();
  const model = await sdk.systemManager.device.getModel();
  try {
    await sdk.userManager.addDevice({
      type: config.get().sdk.deviceType,
      name: `${config.get().sdk.deviceName} - ${deviceId}`,
      description: `${config.get().sdk.deviceName} - ${model}`,
      clientIdentifiers: {
        WMDRM: deviceId
      }
    });
  } catch (e) {
    console.log('addDevice -' , e);
    return e
    // TODO: Investigate async try-catch flows, to see if it's possible to avoid scaling/bubbling new Error up in the try-catch chain.
    //throw e;
  }
}

/**
 * Sends an error report when maximum devices quantity has been reached.
 */
export async function sendMaxDevicesReport() {
  const sdk = await getSdk();
  sdk.playerManager.stop();
  sdk.playerManager.destroy();
  const code = getErrorCode("maxDevicesError");
  await sdk.reportsManager.sendReport(
    { level: "error", event: "Playback", env: config.get().sdk.environment },
    {
      eventId: "PlayerError",
      report: code,
      status: "error",
      parameter: {
        errorCode: code,
        playbackInfo: {
          titleId: this.config.id,
          manifestUrl: this.config.manifest,
          releasePid: this.config.releasePids && this.config.releasePids[0],
          releaseUrl: this.config.releaseUrl,
          quality: this.config.playbackAnalytics.is4KEnabled,
          playerErrorDump: {
            trace: "Maximum devices quantity reached",
            placeInCode: "APP - devices.js"
          }
        }
      }
    }
  );
}
